import React from 'react';
import { ZelligeCorner, ZelligeBg, CrescentStar, Crescent, AID } from './AidOrnaments';
import { GoldParticles, TwinkleStars } from './AidAnimations';

const CRESCENTS = [
  { top: '18%', left: '4%',  size: 48, opacity: 0.12, color: AID.goldDeep },
  { top: '42%', right: '3%', size: 36, opacity: 0.10, color: AID.goldDeep },
  { top: '68%', left: '5%',  size: 30, opacity: 0.09, color: AID.gold     },
  { top: '25%', right: '5%', size: 42, opacity: 0.11, color: AID.goldDeep },
  { bottom: '18%', left: '8%',  size: 28, opacity: 0.08, color: AID.gold     },
  { bottom: '30%', right: '6%', size: 34, opacity: 0.09, color: AID.goldDeep },
];

function AidCornerOverlay() {
  return (
    <div style={{
      position: 'fixed',
      inset: 0,
      pointerEvents: 'none',
      zIndex: 997,
      overflow: 'hidden',
    }}>

      {/* CSS hover */}
      <style>{`
        .aid-crescent {
          transition: opacity 0.3s ease, transform 0.4s cubic-bezier(0.34,1.56,0.64,1);
          pointer-events: auto;
          cursor: default;
        }
        .aid-crescent:hover {
          opacity: 0.55 !important;
          transform: translateY(-10px) rotate(15deg) scale(1.18);
        }
        .aid-zellige {
          transition: transform 0.4s cubic-bezier(0.34,1.56,0.64,1), filter 0.3s ease;
          pointer-events: auto;
          cursor: default;
        }
        .aid-zellige:hover {
          transform: scale(1.10);
          filter:
            drop-shadow( 1px  1px 0px #6b3f15)
            drop-shadow(-1px -1px 0px #6b3f15)
            drop-shadow( 1px -1px 0px #6b3f15)
            drop-shadow(-1px  1px 0px #6b3f15)
            brightness(1.6)
            drop-shadow(0 0 10px rgba(201,162,39,0.55));
        }
        .aid-particle {
          transition: transform 0.25s cubic-bezier(0.34,1.56,0.64,1), filter 0.25s ease;
          pointer-events: auto;
          cursor: default;
        }
        .aid-particle:hover {
          transform: scale(2.8);
          filter: drop-shadow(0 0 5px #e8c662) brightness(1.8);
        }
      `}</style>

      {/* Zellige en fond pleine page — très subtil */}
      <ZelligeBg color={AID.gold} opacity={0.035} />

      {/* Étoiles scintillantes dispersées */}
      <TwinkleStars count={18} />

      {/* ── Coins zellige aux 4 angles ── */}
      <div className="aid-zellige" style={{ position: 'absolute', top: 70, left: 0 }}>
        <ZelligeCorner size={200} color={AID.gold} opacity={0.28} flip="tl" />
      </div>
      <div className="aid-zellige" style={{ position: 'absolute', top: 70, right: 0 }}>
        <ZelligeCorner size={200} color={AID.gold} opacity={0.28} flip="tr" />
      </div>
      <div className="aid-zellige" style={{ position: 'absolute', bottom: 0, left: 0 }}>
        <ZelligeCorner size={200} color={AID.gold} opacity={0.28} flip="bl" />
      </div>
      <div className="aid-zellige" style={{ position: 'absolute', bottom: 0, right: 0 }}>
        <ZelligeCorner size={200} color={AID.gold} opacity={0.28} flip="br" />
      </div>

      {/* ── CrescentStar dispersés — hover interactif ── */}
      {CRESCENTS.map((c, i) => (
        <div key={i} className="aid-crescent" style={{
          position: 'absolute',
          top: c.top, left: c.left, right: c.right, bottom: c.bottom,
          opacity: c.opacity,
        }}>
          <CrescentStar size={c.size} color={c.color} />
        </div>
      ))}

      {/* ── Particules dorées tombantes ── */}
      <GoldParticles count={22} />

      {/* Badge festif en bas au centre */}
      <div style={{
        position: 'absolute',
        bottom: 20,
        left: '50%',
        transform: 'translateX(-50%)',
        background: `linear-gradient(135deg, ${AID.goldDeep}, ${AID.gold})`,
        borderRadius: 30,
        padding: '8px 16px 8px 10px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        boxShadow: '0 6px 24px rgba(168,130,26,0.35)',
        pointerEvents: 'auto',
      }}>
        <Crescent size={22} color="#fff" />
        <div style={{
          fontFamily: "'Reem Kufi', 'Arial', sans-serif",
          fontSize: 11,
          color: '#fff',
          fontWeight: 700,
          letterSpacing: 1.5,
          userSelect: 'none',
        }}>
          AID MOUBARAK
        </div>
      </div>
    </div>
  );
}

export default AidCornerOverlay;
